import { Component } from '@mycolorway/tao';
import { MDCRadio } from '@material/radio';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-radio-button-field', {
  mixins: [eventListenerMixin],

  properties: {
    checked: {
      type: Boolean,
      default: false,
      observer() {
        this.mdcRadio.checked = this.checked;
      },
    },

    disabled: {
      type: Boolean,
      default: false,
      observer() {
        this.mdcRadio.disabled = this.disabled;
      },
    },
  },

  connected() {
    this.mdcRadio = new MDCRadio(this.querySelector('.mdc-radio'));
    this.mdcRadio.checked = this.checked;

    this.listenTo(this.querySelector('input[type="radio"]'), {
      change: this.handleRadioButtonChanged.bind(this),
    });
  },

  disconnected() {
    this.stopListening();
    if (this.mdcRadio) this.mdcRadio.destroy();
  },

  handleRadioButtonChanged(event) {
    const { checked, value } = event.target;

    this.checked = checked;
    this.namespacedTrigger('change', {
      detail: { checked, value },
      bubbles: true,
    });
  },
});
